import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  type IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from "keycloak-angular";

import { environment } from "@/environments/environment";

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(environment.urlPattern, "i"),
  bearerPrefix: "Bearer",
});

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloakUrl,
      realm: environment.realm,
      clientId: environment.clientId,
    },
    initOptions: {
      onLoad: "login-required",
      checkLoginIframe: false,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: "logout",
        sessionTimeout: environment.sessionTimeout,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [urlCondition],
      },
    ],
  });
